import { Button, InputNumber, message } from "antd";
import React from "react";
import { PickerMultiBoxDetailsWrapper } from "./PickerMultiBoxDetails.style";
export default class PickerMultiBoxDetails extends React.Component {
  state = {
    qty: this.props.pendingQuantity ?? this.props.medQty,
  };
  componentDidUpdate = (prevProps) => {
    if (prevProps.pendingQuantity !== this.props.pendingQuantity) {
      this.setState({
        qty: this.props.pendingQuantity ?? this.props.medQty,
      });
    }
  };
  render() {
    const { medQty, previousPickedQty, medName } = this.props;
    return (
      <PickerMultiBoxDetailsWrapper>
        <div className="medName">{medName}</div>
        {/* <div className="qtyWrapper">
          <div className="currentWrapper">
            <div className="qty-label">Actual Quantity</div>
            <div className="qty-value">{medQty}</div>
          </div>
          <div className="remainingWrapper">
            <div className="qty-label">Previously picked Qty</div>
            <div className="qty-value">{previousPickedQty}</div>
          </div>
        </div> */}
        <div className="boxWrapper">
          <div className="boxLabel">Current Box:</div>
          <div className="boxValue">{this.props.boxNumber}</div>
        </div>
        <div className="boxWrapper">
          <div className="boxLabel">Picking QTY:</div>
          <div className="boxValue">{medQty}</div>
        </div>
        <div className="ctaWrapper">
          {/* <div className="quantity-textfield">
            <InputNumber
              onChange={(e) => {
                this.setState({
                  qty: e,
                });
                // let diff = Number(medQty) - Number(previousPickedQty ?? 0);
                // if (Number(e) <= diff) {
                //   this.setState({
                //     qty: e,
                //   });
                // } else {
                //   message.error(`Allowed max quantity is only ${diff}`);
                // }
              }}
              placeholder="Enter Quantity to pick"
              value={this.state.qty}
            />
          </div> */}
          <div className="quantityPickerCTA">
            <Button
              onClick={() => {
                // --------- Passing medQty as partial picking is not possible in latest to flow
                this.props.handlePicker(medQty);
                this.setState({
                  qty: "",
                });
              }}
            >
              Pick
            </Button>
          </div>
        </div>
      </PickerMultiBoxDetailsWrapper>
    );
  }
}
